export default function JackpotDetails(props) {

    const renderJackpotDetails = () => {
        if (!props.jackpotData || !props.jackpotData.pots) return;

        let pots = [];
        props.jackpotData.pots.forEach((pot, i) => {
            pots.push(
                <JackpotTier key={i} pot={pot} />
            )
        })

        return (
            <div>
                ID: {props.jackpotData.id}<br/>
                Name: {props.jackpotData.name}
                {pots}
            </div>
        )
    }

    return (
        <div className="ContributionResultsContainer">
            <div className="ContainerLabel">Jackpot Details</div>
            <div>
                {renderJackpotDetails()}
            </div>
        </div>
    )
}

function JackpotTier(props) {
    if (!props.pot) return;

    let pot = props.pot;

    let potType = "";
    pot.pot_types.forEach((type, index) => {
        potType += index > 0 ? ", " : "" + Object.keys(type)[0];
    });

    const roundMoney = (v) => {
        return Math.round(v * 1000) / 1000;
    }

    return (
        <div className="JackpotTier">
            <ul>
                <li>Tier: {pot.id} ({potType})
                    <ul>
                        <li>Pot value: {roundMoney(pot.current_value)}</li>
                        <li>Contribution to pot: {roundMoney(pot.contributed_amount)}</li>
                        <li>Contribution to seed: {roundMoney(pot.contributed_seed)}</li>
                    </ul>
                </li>
            </ul>
        </div>

    )
}